






























































import PartnerShippingAddressItem from '@/components/molecules/PartnerShippingAddress/PartnerShippingAddressItem.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import confirmMixin from '@/mixin/confirmMixin'
import XConfirm from '@/components/atoms/Confirm/XConfirm.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XPagination from '@/components/atoms/Pagination/XPagination.vue'
import StorePicker from '@/components/molecules/StorePicker/StorePicker.vue'
import GqlQuery from '@/components/atoms/Gql/GqlQuery.vue'
import STORE_SHIPPING_ADDRESSES_QUERY from '@/graphql/partner/storeShippingAddresses.gql'
import CHANGE_STORE_SHIPPING_ADDRESS from '@/graphql/partner/changeMainStoreShippingAddress.gql'
import DELETE_STORE_SHIPPING_ADDRESS from '@/graphql/partner/deleteStoreShippingaddress.gql'
import {
  Maybe,
  Query,
  Store,
  StoreShippingAddress,
} from '@/types/generated/graphql'
import { DocumentNode } from 'graphql'

type Data = {
  storeId: string
  query: DocumentNode
  pagination: {
    first: number
    page: number
    totalPage: number
    caption: {
      total: number
      from?: Maybe<number>
      to?: Maybe<number>
    }
  }
}

type Method = {
  update: (data: Query) => StoreShippingAddress[]
  onStoreLoaded: (stores: Store[]) => void
  onChangeMain: (storeShippingAddress: StoreShippingAddress) => void
  onDelete: (storeShippingAddress: StoreShippingAddress) => void
  onClickBack: () => void
}

type Computed = {
  variables: {
    partnerId: string
    storeId: string
    first: number
    page: number
  }
}

type Props = {
  partnerId: string
}

export default confirmMixin.extend<Data, Method, Computed, Props>({
  name: 'PartnerShippingAddressList',
  mixins: [confirmMixin],
  props: {
    partnerId: {
      type: String,
      required: true,
    },
  },
  components: {
    PartnerShippingAddressItem,
    XButton,
    XConfirm,
    XCard,
    XFormLabel,
    XPagination,
    StorePicker,
    GqlQuery,
  },
  data() {
    return {
      storeId: '',
      query: STORE_SHIPPING_ADDRESSES_QUERY,
      pagination: {
        first: 10,
        page: 1,
        totalPage: 0,
        caption: {
          total: 0,
          from: 0,
          to: 0,
        },
      },
    }
  },
  computed: {
    variables() {
      const { first, page } = this.pagination
      return { partnerId: this.partnerId, storeId: this.storeId, first, page }
    },
  },
  methods: {
    onStoreLoaded(stores: Store[]) {
      if (stores.length === 0) {
        return
      }
      this.storeId = stores[0].storeId
    },
    update({ storeShippingAddresses }) {
      const { data, paginatorInfo } = storeShippingAddresses
      this.pagination = {
        ...this.pagination,
        page: paginatorInfo.currentPage,
        totalPage: paginatorInfo.lastPage,
        caption: {
          total: paginatorInfo.total,
          from: paginatorInfo.firstItem,
          to: paginatorInfo.lastItem,
        },
      }
      return data
    },
    async onChangeMain(storeShippingAddress: StoreShippingAddress) {
      await this.$apollo.mutate({
        mutation: CHANGE_STORE_SHIPPING_ADDRESS,
        variables: {
          storeId: storeShippingAddress.storeId,
          id: storeShippingAddress.storeShippingAddressId,
        },
      })
      const queryTable = this.$refs.queryTable as any
      queryTable.refetch()
    },
    async onDelete(storeShippingAddress: StoreShippingAddress) {
      const okHandler = async () => {
        await this.$apollo.mutate({
          mutation: DELETE_STORE_SHIPPING_ADDRESS,
          variables: {
            storeId: storeShippingAddress.storeId,
            id: storeShippingAddress.storeShippingAddressId,
          },
        })
        const queryTable = this.$refs.queryTable as any
        queryTable.refetch()
      }
      this.showConfirm({ okHandler })
    },
    onClickBack() {
      this.$router.push({ name: 'Partner' })
    },
  },
})
